<template>
  <v-app>
    <v-overlay :value="fullScreenLoader">
      <v-progress-circular
        color="brand-primary"
        indeterminate
        size="64"
      />
    </v-overlay>

    <vue-snotify />

    <cart-drawer
      :items="[]"
      :logo-visible="false"
      :navigation-drawer.sync="navigationDrawerVisible"
    />

    <app-toolbar
      :navigation-drawer.sync="navigationDrawerVisible"
      account
      cart
      lang-switch
      logo
    />

    <v-main>
      <v-container
        class="fill-height"
        fluid
        ma-0
        pa-0
      >
        <v-row v-if="showStoreToolbar">
          <v-col cols="12">
            <store-catalog-toolbar />
            <v-img
              v-if="StoreInfo?.Image"
              :height="storeHeaderImageHeight"
              :src="StoreInfo.Image"
            />
          </v-col>
        </v-row>

        <v-row v-if="showTagToolbar">
          <v-col cols="12">
            <tag-catalog-toolbar />
          </v-col>
        </v-row>

        <v-row class="fill-height">
          <v-col
            :class="{'mt-14': (showStoreToolbar && !StoreInfo?.Image) || showTagToolbar}"
            :lg="$route.name === 'Home' ? 12 : 10"
            :offset-lg="$route.name === 'Home' ? 0 : 1"
            class="py-0"
            cols="12"
          >
            <slot />
          </v-col>
        </v-row>

        <login-dialog :visible.sync="loginDialogVisible" />

        <register-dialog
          :item="registerInitData"
          :visible.sync="registerDialogVisible"
        />

        <reset-password-dialog :visible.sync="resetPasswordDialogVisible" />

        <select-table-dialog
          :items="AppQrItems"
          :visible.sync="selectTableDialogVisible"
        />
      </v-container>
    </v-main>

    <v-bottom-navigation
      v-if="showBottomNavigation"
      app
      background-color="transparent"
      class="mb-2 px-2 elevation-0"
      dark
      fixed
      height="46"
      mandatory
    >
      <v-btn
        class="rounded brand-primary text-capitalize font-weight-bold pl-2 pr-3 elevation-6"
        style="width: 320px; max-width: 320px; font-size: 14px;"
        @click.stop="navigationDrawerVisible = !navigationDrawerVisible"
      >
        <div
          class="d-flex"
          style="width: 100%;"
        >
          <div class="my-auto">
            <v-badge
              class="mt-2 mr-4"
              color="white"
              overlap
            >
              <template #badge>
                <span class="brand-primary--text">{{ cartProductsCount }}</span>
              </template>

              <v-icon>mdi-cart</v-icon>
            </v-badge>

            <span>{{ $t('Cart.Button.ViewCart') }}</span>
          </div>

          <v-spacer />

          <div class="ml-4 my-auto">
            {{ orderTotal | currency }}
          </div>
        </div>
      </v-btn>
    </v-bottom-navigation>

    <app-footer class="mt-12" />

    <confirm-dialog ref="confirm" />

    <cookie-consent
      ref="cc"
      :config="ccConfig"
      :lang="$i18n.locale"
      @change="onCookieConsentChange"
      @consent="applyCookieConsent"
    />
  </v-app>
</template>

<script>
import DefaultLayoutMixin from '@/theme/default/layouts/DefaultLayout.js'
import CookieConsent from '@/theme/default/components/common/cookies/CookieConsent.vue'

export default {
  name      : 'DefaultLayout',
  components: {CookieConsent},
  mixins    : [DefaultLayoutMixin],
  computed  : {
    showBottomNavigation() {
      return false
    },

    storeHeaderImageHeight() {
      switch (this.$vuetify.breakpoint.name) {
      case 'xs':
        return 200
      case 'sm':
        return 250
      case 'md':
        return 400
      case 'lg':
        return 500
      case 'xl':
        return 600
      default:
        return 600
      }
    }
  }
}
</script>

<style scoped src="@/theme/default/layouts/DefaultLayout.css"></style>

<style scoped>

</style>
